// extracted by mini-css-extract-plugin
export default {"productGallery":"GK-z","inQuickShop":"HK-z"};